import { useTranslation } from 'react-i18next'
import { LangText } from '@/components'
import { useNavigate } from 'react-router-dom'
import { preFixImgUrl } from '@/utils'


const ServiceCenter = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div>
      <div className='w-full h-[500px] bg-no-repeat bg-cover bg-center flex items-center justify-center' style={{ backgroundImage: `url(${preFixImgUrl('defd7ee5748e2342ab6374da42e8d103.png')})` }}>
        <div className='text-white flex flex-col w-8xl mx-auto px-10'>
          <LangText lngKey='ea8f2288' className='text-[68px]'>{t('ea8f2288')}</LangText>
          <LangText lngKey='9a53ebd6' className='text-[32px] mt-[48px]'>{t('9a53ebd6')}</LangText>
          <LangText lngKey='16dbde4b' className='text-[32px] mt-[9px]'>{t('16dbde4b')}</LangText>
        </div>
      </div>
      <div className='bg-white'>
        <div className='w-8xl mx-auto px-10 flex items-center pt-[139px] pb-[78px]'>
          <img src={preFixImgUrl('64017d56d3cf2ef51350b4b5e57d2b7d.png')} className='w-[600px] h-[600px] mr-10' />
          <div className='flex flex-col'>
            <LangText lngKey='54f65e85' className='text-[30px]'>{t('54f65e85')}</LangText>
            <LangText lngKey='860ac988' className='text-[20px] text-[#666666] leading-[1.5] mt-[35px]'>{t('860ac988')}</LangText>
            <div className='flex flex-col gap-[22px] mt-[37px]'>
              <div className='flex gap-[15px] items-center'>
                <img className='w-[15px] h-[15px]' src={preFixImgUrl('ffef142fc2145e6f88c35d194a214b99.png')} />
                <LangText lngKey='d9b6bfba' className='text-[20px]'>{t('d9b6bfba')}</LangText>
              </div>
              <div className='flex gap-[15px] items-center'>
                <img className='w-[15px] h-[15px]' src={preFixImgUrl('ffef142fc2145e6f88c35d194a214b99.png')} />
                <LangText lngKey='1e8c93e3' className='text-[20px]'>{t('1e8c93e3')}</LangText>
              </div>
              <div className='flex gap-[15px] items-center'>
                <img className='w-[15px] h-[15px]' src={preFixImgUrl('ffef142fc2145e6f88c35d194a214b99.png')} />
                <LangText lngKey='0f85fd7d' className='text-[20px]'>{t('0f85fd7d')}</LangText>
              </div>
              <div className='flex gap-[15px] items-center'>
                <img className='w-[15px] h-[15px]' src={preFixImgUrl('ffef142fc2145e6f88c35d194a214b99.png')} />
                <LangText lngKey='1269f37a' className='text-[20px]'>{t('1269f37a')}</LangText>
              </div>
            </div>
            <div 
              className='h-[56px] cursor-pointer w-fit rounded-[28px] bg-linear-to-r from-[#00B5D0] to-[#17D3EF] px-[53px] flex items-center justify-center mt-[38px]'
              onClick={()=> navigate('/haneda-shop')}
            >
              <LangText lngKey='f8a58b1a' className='text-[20px] text-white'>{t('f8a58b1a')}</LangText>
            </div>
          </div>
        </div>
      </div>
      <div className='bg-[#F1FBFF]'>
        <div className='w-8xl mx-auto px-10 flex items-center justify-between flex-row-reverse py-[83px]'>
          <img src={preFixImgUrl('1e0399aa9e0032145db13a69c0628c39.png')} className='w-[600px] h-[600px] ml-10' />
          <div className='flex flex-col'>
            <LangText lngKey='11bf2e54' className='text-[30px]'>{t('11bf2e54')}</LangText>
            <LangText lngKey='c4a60325' className='text-[20px] text-[#666666] leading-[1.5] mt-[35px]'>{t('c4a60325')}</LangText>
            <div className='flex flex-col gap-[22px] mt-[37px]'>
              <div className='flex gap-[15px] items-center'>
                <img className='w-[15px] h-[15px]' src={preFixImgUrl('d1acbc95a14e729695558630e1f21fe5.png')} />
                <LangText lngKey='7ac772cf' className='text-[20px]'>{t('7ac772cf')}</LangText>
              </div>
              <div className='flex gap-[15px] items-center'>
                <img className='w-[15px] h-[15px]' src={preFixImgUrl('d1acbc95a14e729695558630e1f21fe5.png')} />
                <LangText lngKey='f0fec48f' className='text-[20px]'>{t('f0fec48f')}</LangText>
              </div>
              <div className='flex gap-[15px] items-center'>
                <img className='w-[15px] h-[15px]' src={preFixImgUrl('d1acbc95a14e729695558630e1f21fe5.png')} />
                <LangText lngKey='f58daef1' className='text-[20px]'>{t('f58daef1')}</LangText>
              </div>
              <div className='flex gap-[15px] items-center'>
                <img className='w-[15px] h-[15px]' src={preFixImgUrl('d1acbc95a14e729695558630e1f21fe5.png')} />
                <LangText lngKey='9642d9ec' className='text-[20px]'>{t('9642d9ec')}</LangText>
              </div>
            </div>
            <div 
              className='h-[56px] cursor-pointer w-fit rounded-[28px] bg-linear-to-r from-[#3984FF] to-[#0DACFF] px-[53px] flex items-center justify-center mt-[38px]'
              onClick={()=> navigate('/sagawa-exp')}
            >
              <LangText lngKey='f8a58b1a' className='text-[20px] text-white'>{t('f8a58b1a')}</LangText>
            </div>
          </div>
        </div>
      </div>
      <div className='bg-white'>
        <div className='w-8xl mx-auto px-10 flex items-center pt-[139px] pb-[78px]'>
          <img src={preFixImgUrl('a02f44d08a90867eaf0c52f73f5b951b.png')} className='w-[600px] h-[600px] mr-10' />
          <div className='flex flex-col'>
            <LangText lngKey='127c9e7e' className='text-[30px]'>{t('127c9e7e')}</LangText>
            <LangText lngKey='3930ed6e' className='text-[20px] text-[#666666] leading-[1.5] mt-[35px]'>{t('3930ed6e')}</LangText>
            <div className='flex flex-col gap-[22px] mt-[37px]'>
              <div className='flex gap-[15px] items-center'>
                <img className='w-[15px] h-[15px]' src={preFixImgUrl('f1b48db3ec5382dfd44d9c0b3312eb26.png')} />
                <LangText lngKey='ce88427d' className='text-[20px]'>{t('ce88427d')}</LangText>
              </div>
              <div className='flex gap-[15px] items-center'>
                <img className='w-[15px] h-[15px]' src={preFixImgUrl('f1b48db3ec5382dfd44d9c0b3312eb26.png')} />
                <LangText lngKey='2da4b162' className='text-[20px]'>{t('2da4b162')}</LangText>
              </div>
              <div className='flex gap-[15px] items-center'>
                <img className='w-[15px] h-[15px]' src={preFixImgUrl('f1b48db3ec5382dfd44d9c0b3312eb26.png')} />
                <LangText lngKey='de3a4ea0' className='text-[20px]'>{t('de3a4ea0')}</LangText>
              </div>
              <div className='flex gap-[15px] items-center'>
                <img className='w-[15px] h-[15px]' src={preFixImgUrl('f1b48db3ec5382dfd44d9c0b3312eb26.png')} />
                <LangText lngKey='4bd330c5' className='text-[20px]'>{t('4bd330c5')}</LangText>
              </div>
            </div>
            <div 
              className='h-[56px] cursor-pointer w-fit rounded-[28px] bg-linear-to-r from-[#F8C487] to-[#FEE3B8] px-[53px] flex items-center justify-center mt-[38px]'
              onClick={()=> navigate('/vip')}
            >
              <LangText lngKey='f8a58b1a' className='text-[20px]'>{t('f8a58b1a')}</LangText>
            </div>
          </div>
        </div>
      </div>
      <div className='bg-[#FFFBF6]'>
        <div className='w-8xl mx-auto px-10 flex items-center justify-between flex-row-reverse py-[83px]'>
          <img src={preFixImgUrl('35b94a55a95e8511f971570ff491ec95.png')} className='w-[600px] h-[600px] ml-10' />
          <div className='flex flex-col'>
            <LangText lngKey='88f51026' className='text-[30px]'>{t('88f51026')}</LangText>
            <LangText lngKey='983acf36' className='text-[20px] text-[#666666] leading-[1.5] mt-[35px]'>{t('983acf36')}</LangText>
            <div className='flex flex-col gap-[22px] mt-[37px]'>
              <div className='flex gap-[15px] items-center'>
                <img className='w-[15px] h-[15px]' src={preFixImgUrl('ad8aed4acb9221be1182e6670fd7d234.png')} />
                <LangText lngKey='309abac2' className='text-[20px]'>{t('309abac2')}</LangText>
              </div>
              <div className='flex gap-[15px] items-center'>
                <img className='w-[15px] h-[15px]' src={preFixImgUrl('ad8aed4acb9221be1182e6670fd7d234.png')} />
                <LangText lngKey='26ef20e6' className='text-[20px]'>{t('26ef20e6')}</LangText>
              </div>
              <div className='flex gap-[15px] items-center'>
                <img className='w-[15px] h-[15px]' src={preFixImgUrl('ad8aed4acb9221be1182e6670fd7d234.png')} />
                <LangText lngKey='2d9effc1' className='text-[20px]'>{t('2d9effc1')}</LangText>
              </div>
              <div className='flex gap-[15px] items-center'>
                <img className='w-[15px] h-[15px]' src={preFixImgUrl('ad8aed4acb9221be1182e6670fd7d234.png')} />
                <LangText lngKey='6daa118f' className='text-[20px]'>{t('6daa118f')}</LangText>
              </div>
            </div>
            <div 
              className='h-[56px] cursor-pointer w-fit rounded-[28px] bg-[#FF9D34] px-[53px] flex items-center justify-center mt-[38px]'
              onClick={()=> navigate('/coupon')}
            >
              <LangText lngKey='f8a58b1a' className='text-[20px] text-white'>{t('f8a58b1a')}</LangText>
            </div>
          </div>
        </div>
      </div>
      <div className='bg-white'>
        <div className='w-8xl mx-auto px-10 flex items-center pt-[139px] pb-[78px]'>
          <img src={preFixImgUrl('6d3162e19f80389440d3da6e1d207c6c.png')} className='w-[600px] h-[600px] mr-10' />
          <div className='flex flex-col'>
            <LangText lngKey='b43302de' className='text-[30px]'>{t('b43302de')}</LangText>
            <LangText lngKey='0508676a' className='text-[20px] text-[#666666] leading-[1.5] mt-[35px]'>{t('0508676a')}</LangText>
            <div className='flex flex-col gap-[22px] mt-[37px]'>
              <div className='flex gap-[15px] items-center'>
                <img className='w-[15px] h-[15px]' src={preFixImgUrl('35d4cb318e7a599c05beef7f23ad00f7.png')} />
                <LangText lngKey='80603592' className='text-[20px]'>{t('80603592')}</LangText>
              </div>
              <div className='flex gap-[15px] items-center'>
                <img className='w-[15px] h-[15px]' src={preFixImgUrl('35d4cb318e7a599c05beef7f23ad00f7.png')} />
                <LangText lngKey='780c876a' className='text-[20px]'>{t('780c876a')}</LangText>
              </div>
              <div className='flex gap-[15px] items-center'>
                <img className='w-[15px] h-[15px]' src={preFixImgUrl('35d4cb318e7a599c05beef7f23ad00f7.png')} />
                <LangText lngKey='19c3a483' className='text-[20px]'>{t('19c3a483')}</LangText>
              </div>
              <div className='flex gap-[15px] items-center'>
                <img className='w-[15px] h-[15px]' src={preFixImgUrl('35d4cb318e7a599c05beef7f23ad00f7.png')} />
                <LangText lngKey='e8e80dd1' className='text-[20px]'>{t('e8e80dd1')}</LangText>
              </div>
            </div>
            <div 
              className='h-[56px] cursor-pointer w-fit rounded-[28px] bg-linear-to-r from-[#34A81D] to-[#62C647] px-[53px] flex items-center justify-center mt-[38px]'
              onClick={()=> navigate('/car-rental')}
            >
              <LangText lngKey='f8a58b1a' className='text-[20px] text-white'>{t('f8a58b1a')}</LangText>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ServiceCenter;